module.exports = __webpack_public_path__ + "img/you.8ad64e62.svg";